import React from 'react';
import { Card, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { getSortOrder, getTableFilters } from '../../../utilities/SessionStorage';
import DataTable from '../../DataTable/datatable.component';
import DateColumn from '../../DataTable/datatable.datecolumn';
import SelectFilter from '../../DataTable/datatable.selectfilter';
import { AddQIRCommentButton } from './AddQIRCommentButton';

function QIRComments({ qir, businessUnitDetails, refresh }) {
    const { t } = useTranslation();

    const tableColumns = [
        DateColumn({ header: t('QIRComments.ColHead.CommentDate'), accessor: 'commentDate' }),
        {
            Header: t('QIRComments.ColHead.Reason'),
            accessor: 'commentReasonCode',
            Filter: SelectFilter
        },
        {
            Header: t('QIRComments.ColHead.User'),
            accessor: 'account',
            filter: 'includesString'
        },
        {
            Header: t('QIRComments.ColHead.Comment'),
            accessor: 'comment',
            filter: 'includesString'
        }
    ];

    const initialState = {
        pageSize: 20,
        hiddenColumns: ['qirId'],
        sortBy: [
            {
                id: 'commentDate',
                desc: true
            }
        ]
    };

    const tableId = "QIRCommentsList";
    const sortBy = getSortOrder(tableId);
    const filters = getTableFilters(tableId);

    if (sortBy) {
        initialState.sortBy = sortBy;
    }

    if (filters) {
        initialState.filters = filters;
    }

    return (
        <Card className="mb-2">
            <Card.Header>{t('QIRDetail.Sections.QIRComments')}</Card.Header>
            <Card.Body>
                {qir.comments.length > 0 &&
                    <Row>
                        <DataTable id={tableId} tableColumns={tableColumns} tableData={qir.comments} initialState={initialState} />
                    </Row>
                }
                <Row>
                    <div className="d-flex justify-content-end">
                        <AddQIRCommentButton qir={qir} refresh={refresh} businessUnitDetails={businessUnitDetails} />
                    </div>
                </Row>
            </Card.Body>
        </Card>
    );
}

export default QIRComments;;